import axios from '../helpers/axios'
import { logError } from '../services';
import {
  INavigationHierarchy,
  INavigationRoleIds,
  INavigationAuthorization
} from '../models';

const baseUrl = '/api/navigations';

export const getNavigationHierarchy = async (): Promise<INavigationHierarchy[]> => {
  try {
    const { data } = await axios.get(`${baseUrl}/hierarchy`);
    return data;
  } catch (error) {
    logError(error, 'getNavigationHierarchy failed');
    return Promise.reject(error);
  }
};

export const getNavigationIdsForRole = async (roleId: number): Promise<INavigationRoleIds[]> => {
  try {
    const { data } = await axios.get(`${baseUrl}/application-roles/${roleId}`);
    return data;
  } catch (error) {
    logError(error, 'getNavigationIdsForRole failed');
    return Promise.reject(error.response.data);
  }
};

export const updateNavigationAuthorization = async (
  roleId: string | number,
  payload: INavigationAuthorization
): Promise<any> => {
  try {
    const { data } = await axios.put(`${baseUrl}/application-roles/${roleId}`, payload);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: { roleId: roleId, authorization: payload }
      },
      'updateNavigationAuthorization failed'
    );
    return Promise.reject(error.response.data);
  }
};

export const getAvailableNavigation = async (): Promise<string[]> => {
  try {
    const { data } = await axios.get('/api/available-navigation');
    return data;
  } catch (error) {
    logError({ error }, 'getAvailableNavigation failed');
    return Promise.reject(error?.response?.data);
  }
};